import { Flex, Paper } from '@mantine/core';
import { useState } from 'react';

import { CriteriaProjectFreeTextChangeForm } from '@/module/Laboratory/criteria/components/CriteriaProjectFreeTextChangeForm';
import { FreeText } from '@/module/ResearchCenter';

import { CriteriaItemEditButton } from './CriteriaItemEditButton';

interface CriteriaFreeTextCardProps {
  index?: number;
  freeText: FreeText;
  onChange: (freeText: FreeText) => void;
  isPending: boolean;
  completed: boolean;
}

export function CriteriaFreeTextCard({ freeText, index, onChange, isPending, completed}: CriteriaFreeTextCardProps) {
  const [isEditable, setIsEditable] = useState(false);

  if (isEditable) {
    return (
      <CriteriaProjectFreeTextChangeForm
        defaultValues={freeText}
        onChange={onChange}
        isSubmitting={isPending}
        onCancel={() => setIsEditable(false)}
      />
    );
  }
  return (
    <Paper
      px="10px"
      bg="#FBFBFB"
      mr="6px"
      flex={1}
    >
      <Flex>
        {!completed &&
        <CriteriaItemEditButton
          index={index}
          onEdit={() => setIsEditable(true)}
        />
        }
        <div dangerouslySetInnerHTML={{ __html: freeText.text }} />
      </Flex>
    </Paper>
  );
}
